<template>
  <div class="fld">
    <span class="fld__icon"><v-icon>mdi-clock-outline</v-icon></span>
    <div style="min-width: 0">
      <span class="fld__label">Verfügbarkeiten</span>
      <div v-if="!hasAvailabilities" class="fld__value fld__value--muted">Keine Verfügbarkeiten hinterlegt</div>
      <availability-panel v-else :loading="loading" :real-time="disableRealTime ? undefined : realTime" :stored="institution.availabilities"/>
    </div>
    <div class="fld__actions">
      <button v-if="canUpdate" :class="{ 'ibtn--add': !hasAvailabilities }" class="ibtn" v-tip="'Verfügbarkeiten bearbeiten'" aria-label="Verfügbarkeiten bearbeiten" type="button"
              @click="showDialog = true">
        <v-icon>{{ hasAvailabilities ? 'mdi-pencil-outline' : 'mdi-plus' }}</v-icon>
      </button>
    </div>
    <update-institution-availabilities-dialog v-model="showDialog" :institution-id="institution._id" @update:availabilities="onUpdate"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import AvailabilityPanel from '@/components/common/availability/AvailabilityPanel.vue';
import UpdateInstitutionAvailabilitiesDialog
  from '@/components/institutions/institutionView/profileView/availabilitiesListItem/updateInstitutionAvailabilitiesDialog.vue';
import {SchedulerApi} from '@/classes/api/scheduler.api.class';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {InstitutionFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/InstitutionFields';
import {AvailabilityInterface, LabeledAvailabilityInterface} from '@/interfaces/availability.interface';
import {Institution} from '@/interfaces/institution.interface';
import {EventBus} from '@/busses/EventBus';


/** Availabilities field (AvailabilityPanel: label filter, Terminabgleich, mini week timeline, "Zuletzt aktualisiert … von") */
export default Vue.extend({
  components: {AvailabilityPanel, UpdateInstitutionAvailabilitiesDialog},
  props: {
    institution: {type: Object as () => Institution, required: true},
  },
  data: () => ({
    loading: false,
    showDialog: false,
    disableRealTime: false,
    realTime: [] as LabeledAvailabilityInterface[],
  }),
  computed: {
    hasAvailabilities(): boolean {
      return !!this.institution.availabilities?.length;
    },
    canUpdate(): boolean {
      const entity = this.$$getCrudEntity(CrudEntityTypes.INSTITUTION, this.institution._id);
      return entity.canRead(InstitutionFields.AVAILABILITIES) && entity.canUpdate(InstitutionFields.AVAILABILITIES);
    },
  },
  methods: {
    onUpdate(availabilities: AvailabilityInterface[] | null) {
      this.$set(this.institution, 'availabilities', availabilities);
      this.loadRealTime();
    },
    async loadRealTime() {
      if (!this.$$getCrudEntity(CrudEntityTypes.INSTITUTION, this.institution._id).canRead(InstitutionFields.AVAILABILITIES)) {
        this.disableRealTime = true;
        return;
      }
      this.loading = true;
      try {
        const resp = await SchedulerApi.getAvailabilities({type: CrudEntityTypes.INSTITUTION, id: this.institution._id});
        this.realTime = resp.availabilities;
        this.disableRealTime = false;
      } catch (e) {
        this.disableRealTime = true;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    'institution._id': {
      immediate: true,
      handler() {
        this.loadRealTime();
      },
    },
  },
  mounted() {
    EventBus.$on('update:availabilities', this.loadRealTime);
  },
  beforeDestroy() {
    EventBus.$off('update:availabilities', this.loadRealTime);
  },
});
</script>

<style src="./itemDetails.css"></style>
<style src="./acquisitionViews.css"></style>
